
import HeaderTwo from "../components/HeaderTwo/HeaderTwoSection";
import Footer from "../components/Footer/FooterSection";
import "../styles/infopage.scss"
// import { NavLink } from "react-router-dom";


const AboutUs = () => {

    return (
        <>
            <HeaderTwo></HeaderTwo>

            <div className="infopage content animate__animated animate__fadeIn animate__fast">
                <div className="section">
                    <h1>Yayako Express – About Us</h1>
                    <p>
                        <strong>Welcome to Yayako Express Limited</strong> – your global online marketplace for quality products at unbeatable prices.
                    </p>
                    <p>Founded with a mission to make shopping smarter, easier, and more affordable, Yayako Express Limited is a dynamic e-commerce platform that connects buyers directly with manufacturers, suppliers, and distributors from around the world. Whether you’re shopping for the latest electronics, trendy fashion, home essentials, beauty products, or unique gadgets, Yayako Express brings a world of products to your fingertips, all in one place.
                    </p>
                </div>


                <div className="section">
                    <h2>What We Do</h2>
                    <p>At Yayako Express, we empower millions of customers to shop with confidence by offering a seamless, secure, and personalized shopping experience. Our platform enables businesses of all sizes especially small and medium-sized enterprises (SMEs) to reach global customers, expand their brands, and grow beyond borders.</p>
                    <p>We are more than just a marketplace. We are a bridge that connects high-quality global supply with everyday consumers who demand value, convenience, and variety.</p>
                </div>

                <div className="section">
                    <h2>Why Shop with Yayako Express?</h2>
                    <ul>
                        <li><strong>Wide Product Selection:</strong> Explore an ever growing catalog of affordable products across multiple categories.</li>
                        <li><strong>Direct-from-Source Prices:</strong> We eliminate the middleman so you can enjoy factory direct pricing.</li>
                        <li><strong>Secure Shopping:</strong> Your privacy and security are our top priorities. Our secure payment systems and buyer protection policies ensure peace of mind.</li>
                        <li><strong>Personalized Experience:</strong> Enjoy product recommendations, flash deals, and loyalty programs tailored just for you.</li>
                    </ul>

                </div>

                <div className="section">
                    <h2>Our Vision</h2>
                    <p>To become a leading global e-commerce hub where innovation, affordability, and accessibility meet by empowering individuals and businesses to thrive in the digital economy.</p>

                </div>

                <div className="section">
                    <h2>Our Mission</h2>
                    <ul>
                        <li>To simplify global trade through technology and innovation.</li>
                        <li>To provide customers with access to high quality, cost effective products worldwide.</li>
                        <li>To support sellers with the tools and resources needed for success in the global market.</li>
                    </ul>
                </div>

                <div className="section">
                    <h2>Join Our Community</h2>
                    <p>
                        With millions of products, thousands of sellers, and customers from every corner of the globe, Yayako Express is not just a platform, it’s a thriving global shopping community. Whether you're a buyer looking for a great deal or a seller seeking growth, Yayako Express is your trusted partner.
                    </p>
                </div>
                 <div className="section">
                    <h3>Yayako Express Limited – Your World, Delivered.</h3>
                </div>

            </div>

            <Footer></Footer>

        </>
    )

}

export default AboutUs